import { DeviceIdPlugin } from "../plugins/device_id_plugin.js";

const DEVICE_ID_KEY = 'device_id';

function makeUuid(): string
{
  if ( typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function' )
  {
    return crypto.randomUUID();
  }
  return `${Date.now()}_${Math.random().toString( 36 ).slice( 2 )}`;
}

// Resolves a stable device identifier, persisted in localStorage. On the very
// first launch it prefers the native Android ID (survives reinstall / clear
// data), so a guest can recover their account; falls back to a random UUID on
// web / iOS / Telegram. Once resolved it is cached and reused for the session.
export async function ensureDeviceId(): Promise<string>
{
  const stored = getStoredDeviceId();
  if ( stored )
  {
    return stored;
  }

  const android_id = await DeviceIdPlugin.getAndroidId();
  const id = android_id ?? makeUuid();

  localStorage.setItem( DEVICE_ID_KEY, id );
  return id;
}

export function getStoredDeviceId(): string | null
{
  try { return localStorage.getItem( DEVICE_ID_KEY ); }
  catch { return null; }
}

export function resetDeviceIdForNewUser(): string
{
  const id = makeUuid();
  localStorage.setItem( DEVICE_ID_KEY, id );
  return id;
}
